import regex from "services/regex";

const validate = (values) => {
  let _errors = {};


  if (values["email"] && !regex.email.test(values["email"])) {
    _errors["email"] = app.translate(
      "routes.home.basic.personnel.Email is not valid"
    );
  } else {
    delete _errors["email"];
  }

  
  return _errors;
};

export default validate;
